import React from 'react';
import { Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../Shared/GlobalContext/ThemeContext';
import { detectTextDirection } from '../../../../../../Utils/textDirection';

const { Text } = Typography;

const MessageInfoSection = ({ title, content, children, titleColor }) => {
    const { isDarkMode = false } = useTheme() || {};

    if (!content && !children) return null;

    const themeColors = {
        cardBackground: isDarkMode ? '#1f1f1f' : '#fff',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
    };

    return (
        <Card
            title={titleColor ? <span style={{ color: titleColor }}>{title}</span> : title}
            style={{ background: themeColors.cardBackground }}
        >
            {content && <Text dir={detectTextDirection(content)} style={{ color: themeColors.text, whiteSpace: 'pre-wrap', unicodeBidi: 'plaintext' }}>{content}</Text>}
            {children}
        </Card>
    );
};

export default MessageInfoSection;
